import { ErrorHandler, inject, Injectable } from '@angular/core';

import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorService implements ErrorHandler {
  private loggerService = inject(LoggerService);

  handleError(error: Error) {
    this.loggerService.handleError(error);
  }
}
